export default __webpack_public_path__ + "static/media/icon-mobileupload-gray.c78abc0a.svg";